//frontend/src/components/dashboard/ScheduleDialog.js
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    FormControlLabel,
    Checkbox,
    Typography
} from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { parseISO, format } from 'date-fns';
import { useTranslation } from 'react-i18next';

const defaultWorkingHours = [
    { dayOfWeek: 1, startTime: '09:00', endTime: '18:00', isWorking: true, breaks: [] },
    { dayOfWeek: 2, startTime: '09:00', endTime: '18:00', isWorking: true, breaks: [] },
    { dayOfWeek: 3, startTime: '09:00', endTime: '18:00', isWorking: true, breaks: [] },
    { dayOfWeek: 4, startTime: '09:00', endTime: '18:00', isWorking: true, breaks: [] },
    { dayOfWeek: 5, startTime: '09:00', endTime: '18:00', isWorking: true, breaks: [] },
    { dayOfWeek: 6, startTime: '09:00', endTime: '18:00', isWorking: false, breaks: [] },
    { dayOfWeek: 7, startTime: '09:00', endTime: '18:00', isWorking: false, breaks: [] }
];

export default function ScheduleDialog({ 
    open, 
    onClose, 
    specialist, 
    onSave 
}) {
    const { t } = useTranslation();
const weekDays = [
    t('common.monday'), 
    t('common.tuesday'), 
    t('common.wednesday'), 
    t('common.thursday'), 
    t('common.friday'), 
    t('common.saturday'), 
    t('common.sunday')
];    const [workingHours, setWorkingHours] = useState(defaultWorkingHours);


    useEffect(() => {
        if (specialist && specialist.workingHours && specialist.workingHours.length > 0) {
            const updatedHours = specialist.workingHours.map((day, index) => ({
                dayOfWeek: day.dayOfWeek || index + 1,
                startTime: day.startTime || '09:00',
                endTime: day.endTime || '18:00',
                isWorking: day.isWorking !== undefined ? day.isWorking : index < 5,
                breaks: day.breaks || []
            }));
            setWorkingHours(updatedHours);
        } else {
            setWorkingHours(defaultWorkingHours);
        }
    }, [specialist]);

    const handleTimeChange = (dayIndex, field, value) => {
        if (!value) return;
        
        const formattedTime = format(value, 'HH:mm');
        const newHours = [...workingHours];
        newHours[dayIndex] = {
            ...newHours[dayIndex],
            [field]: formattedTime
        };
        setWorkingHours(newHours);
    };

    const handleWorkingDayToggle = (dayIndex) => {
        const newHours = [...workingHours];
        newHours[dayIndex] = {
            ...newHours[dayIndex],
            isWorking: !newHours[dayIndex].isWorking
        };
        setWorkingHours(newHours);
    };

    const createTimeDate = (timeString) => {
        const today = new Date();
        const [hours, minutes] = timeString.split(':');
        const date = new Date(today);
        date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
        return date;
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>
                {t('common.setworkinghoursfor')} {specialist?.name}
                </DialogTitle>
                <DialogContent>
                    {weekDays.map((day, index) => (
                        <Box key={day} sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={workingHours[index]?.isWorking ?? false}
                                        onChange={() => handleWorkingDayToggle(index)}
                                    />
                                }
                                label={<Typography variant="subtitle1">{day}</Typography>}
                            />
                            <Box sx={{ ml: 4, mt: 1, display: 'flex', gap: 2 }}>
                                <TimePicker
                                    label={t('common.starttime')}
                                    value={createTimeDate(workingHours[index]?.startTime || '09:00')}
                                    onChange={(newValue) => handleTimeChange(index, 'startTime', newValue)}
                                    disabled={!workingHours[index]?.isWorking}
                                    ampm={false}
                                    minutesStep={5}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            sx={{ width: 150 }} 
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    }
                                />
                                <TimePicker
                                    label={t('common.endtime')}
                                    value={createTimeDate(workingHours[index]?.endTime || '18:00')}
                                    onChange={(newValue) => handleTimeChange(index, 'endTime', newValue)}
                                    disabled={!workingHours[index]?.isWorking}
                                    ampm={false}
                                    minutesStep={5}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            sx={{ width: 150 }} 
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    }
                                />
                            </Box>
                        </Box>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>{t('common.cancel')}</Button>
                    <Button onClick={() => onSave(workingHours)} variant="contained" color="primary">
                    {t('common.saveschedule')}
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}